import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PseicAutofocusDirective } from './pseic-autofocus/pseic-autofocus.directive';
import { PseicInvalidControlAutoscrollContainerDirective } from './pseic-invalid-control-autoscroll-container/pseic-invalid-control-autoscroll-container.directive';
import { PseicInvalidControlAutoscrollDirective } from './pseic-invalid-control-autoscroll/pseic-invalid-control-autoscroll.directive';


@NgModule({
  declarations: [PseicAutofocusDirective, PseicInvalidControlAutoscrollContainerDirective, PseicInvalidControlAutoscrollDirective],
  exports: [
    PseicAutofocusDirective,
    PseicInvalidControlAutoscrollContainerDirective,
    PseicInvalidControlAutoscrollDirective
  ],
  imports: [
    CommonModule
  ]
})
export class PseicDirectivesModule {
}
